module.exports = __webpack_public_path__ + "assets/img/restart1.06d481b4.png";